import { Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { usePBIRejected } from '../../../../state'
import { usePBIAPRText, usePBIDueTodayText, usePBIEveryText } from '../../helper'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../../utils/responsive'

export const PayInFourRadioLabel: FunctionComponent = () => {
  const hasPBIRejected = usePBIRejected()
  const { textSize } = useCheckoutSizes()

  const paymentsTextDueToday = usePBIDueTodayText()
  const paymentIntervalTextPBI = usePBIEveryText()
  const paymentAPRInterestPBI = usePBIAPRText()

  return (
    <div>
      <div className={styles.headingText}>
        <Text bold size={textSize} color={hasPBIRejected ? 'Gray60' : 'Black'}>
          {paymentIntervalTextPBI}
        </Text>
      </div>
      <div className={styles.downPaymentText}>
        {!hasPBIRejected && (
          <Text size={textSize} color={hasPBIRejected ? 'Gray80' : 'Gray50'}>
            {paymentsTextDueToday}
          </Text>
        )}
      </div>
      <div className={styles.interestText}>
        <Text size={textSize} color={hasPBIRejected ? 'Gray80' : 'Gray50'}>
          {paymentAPRInterestPBI}
        </Text>
      </div>
    </div>
  )
}
